<template>
    <div>



        <h3>
          <p style="color: #6C7A80;">
            ฐานข้อมูลเห็ดพิษ (ThaiMushroom.net) กรมวิทยาศาสตร์การแพทย์ ร่วมกับมหาวิทยาลัยมหาสารคาม ภาคีเครือข่ายนักวิชาการสาธารณสุขและภาคประชาชนร่วมจัดทำขึ้นเพื่อเป็นเครื่องมือคัดกรองเห็ดพิษแบบรวดเร็ว เพื่อการศึกษาและเตือนภัยประชาชนประกอบการตัดสินใจ
          </p>
        </h3>


<!--            <a href="http://www.tumdee.org/alert/cms_article.php?aid=26" target="_blank">-->
<!--                <img src="http://www.tumdee.org/alert/doc_cms/brochures_mushroom_dmsc2560_1.png" class="img-responsive">-->
<!--            </a><br>-->
<!--            <a href="http://www.tumdee.org/alert/cms_article.php?aid=26" target="_blank">-->
<!--                <img src="http://www.tumdee.org/alert/doc_cms/brochures_mushroom_dmsc2560_2.png" class="img-responsive">-->
<!--            </a>-->

        <!--<h2 style="color: #84B329; padding-top: 20px;">
            จะดีไหม? ...ถ้ามีแอพให้ตรวจสอบชนิดเห็ดพิษ..
        </h2>
        <p style="color: #6C7A80;">
            องค์ความรู้ในการวิเคราะห์เห็ดพิษ/เห็ดกินได้
            ได้รับการสืบทอดจากรุ่นสู่รุ่นในชุมชนและจากผู้เชี่ยวชาญที่ศึกษาด้านเห็ดมาโดยเฉพาะ
            ซึ่งแต่ละแห่งชนิดเห็ดจะแตกต่างกัน
            แม้แต่เห็ดชนิดเดียวกันต่างภูมิภาค ต่างสิ่งแวดล้อม
            ลักษณะของเห็ดก็จะแตกต่างกันไปด้วย
        </p>

        <p style="color: #6C7A80;">
            องค์ความรู้เหล่านี้นับวันจะได้รับการสืบทอดน้อยลง เนื่องจากวิถีชีวิตเปลี่ยนไป
            เป็นไปได้หรือไม่ที่จะทำให้องค์ความรู้เหล่านี้
            เก็บสะสมไว้ในรูปแบบดิจิตอล พร้อมทั้งช่วยวิเคราะห์ชนิดเห็ดต่างๆ
            เพื่อใช้ประโยชน์ต่างๆ ในอนาคต
            รวมถึงการตรวจสอบเห็ดที่ไม่มั่นใจว่ากินได้
            เพื่อลดโอกาสในการเสียชีวิตจากการรับประทานเห็ดพิษ
        </p>
        <h2 style="color: #397BE5;">Machine Learning คืออะไร?</h2>
        <p style="color: #6C7A80;"> เป็นสาขาหนึ่งของปัญญาประดิษฐ์ที่พัฒนามาจากการศึกษาการรู้จำแบบ
                    เกี่ยวข้องกับการศึกษาและการสร้างอัลกอริทึมที่สามารถเรียนรู้ข้อมูลและทำนายข้อมูลได้
                    อัลกอริทึมนั้นจะทำงานโดยอาศัยโมเดลที่สร้างมาจากชุดข้อมูลตัวอย่างขาเข้าเพื่อการทำนายหรือตัดสินใจในภายหลัง
                    แทนที่จะทำงานตามลำดับของคำสั่งโปรแกรมคอมพิวเตอร์ </p>

        <h2 style="color: #e59242;">TensorFlow คืออะไร?</h2>
        <p style="color: #6C7A80;">
            TensorFlow™ is an open source software library for numerical computation using
            data flow graphs. Nodes in the graph represent mathematical operations, while
            the graph edges represent the multidimensional data arrays (tensors)
            communicated between them. The flexible architecture allows you to deploy
            computation to one or more CPUs or GPUs in a desktop, server, or mobile device
            with a single API. TensorFlow was originally developed by researchers and
            engineers working on the Google Brain Team within Google's Machine Intelligence
            research organization for the purposes of conducting machine learning and deep
            neural networks research, but the system is general enough to be applicable in a
            wide variety of other domains as well.
        </p>

        <h2 style="color: #397BE5;">ร่วมพัฒนาระบบวิเคราะห์เห็ดกับเรา</h2>
        <p style="color: #6C7A80;">
            ท่านสามารถส่งภาพเห็ดพร้อมระบุชนิดเห็ด พร้อมระบุจังหวัดและแหล่งที่พบเห็ดดังกล่าว
            มาที่ <strong>swindowone@gmail.com</strong>
            (หากไม่ทราบชนิดเห็ดให้ระบุว่าไม่ทราบ)
        </p>-->
    </div>
</template>

<script>
    module.exports = {
      data: function () {
        return {

        }
      }
    }
</script>



// WEBPACK FOOTER //
// InfoApp.vue?ce86a8e4